import { useEffect, useState } from "react";
import InformationToolTip from "../../../../common/components/InformationToolTip";
import { FilterInformationContent, TableInformationContent, DashboardInformationContent } from "./InfomationDetails";

export default function InfoToolTip({ component }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        const clearToolTipOnScroll = () => {
            // Close the tooltip when scrolling
            setTooltipOpen(false);
        };

        window.addEventListener('scroll', clearToolTipOnScroll);
        return () => {
            window.removeEventListener('scroll', clearToolTipOnScroll);
        };
    }, []);

    let InformationContent = null;

    if (component === "filter") {
        InformationContent = FilterInformationContent;
    } else if (component === 'dashboard') {
        InformationContent = DashboardInformationContent;
    } else if (component === 'table') {
        InformationContent = TableInformationContent;
    } else {
        InformationContent = <div>No information available.</div>;
    }


    const handleTooltipChange = (value) => {
        setTooltipOpen(value);
    };

    return <InformationToolTip onChange={handleTooltipChange} open={tooltipOpen} information={InformationContent} />
}